import React from "react";
import { Helmet } from "react-helmet";
import Banner from "../../../component/Banner";
import image1 from "../../../images/financial/retail1.webp";

const RetailWholesale = () => {
  const banner = {
    title: "Retail & Wholesale Bankingy",
    image: image1,
  };

  return (
    <>
      <Helmet>
        <title>
          Retail & Wholesale banking — Cylon Technologies – Big Data | Data
          Analytics | Digital Strategy
        </title>
      </Helmet>
      <Banner heading={banner.title} bannerimg={banner.image} />
      <section className="sec-padd page_content heading_space pb-5 small_ul">
        <div className="container">
          <div className="row g-md-5 g-4 justify-content-between">
            <div className="col-md-7">
              <h2 className="heading2">Services</h2>
              <p>
                Cylon Technologies understand the intricacies of wholesale and retail banking that is why we offer tailored banking services and solutions across various lines of businesses so that you can grow and run your businesses effectively and efficiently. Our team has extensive banking experience with multiple lines of businesses having served global banks across geographies.
              </p>
              <p>
                The global banking scenario is struggling with tough macroeconomic conditions, higher regulatory scrutiny, and rise of the non-traditional competitors and as such, banks are now transitioning from product centric approach to a customer-focused approach to ensure secure and convenient services from everywhere and any time.
              </p>
              <p>
                Cylon Technologies strong combination of industry and banking IT solutions expertise is resulting in the successful delivery of solutions to many clients.  We had delivered developed process knowledge across wholesale/retail banking sub-domains.
              </p>
              <p>
                Our innovative banking services and supply models help us deliver business value through services such as data driven transformation, risk and regulatory compliance, digital enablement, new collaborations across retail and wholesale banking, payments, trade, finance, capital markets, asset/wealth management, custody and settlement.
              </p>

              <h5>
                Cylon Technologies retail banking solutions cover all the business lines of retail bank, including the overall support of operations in areas such as-
              </h5>
              <ul>
                <li>
                  Credit and Debit Cards
                </li>
                <li>
                  Loans and Mortgages
                </li>
                <li>Current and Saving Accounts</li>
                <li>
                  Insurance
                </li>
                <li>
                  Payment and Fund Transfers
                </li>
                <li>Investments</li>
                <li>Securities</li>

              </ul>
              <p>Cylon Technologies continues to deliver customized solutions for banks who want to stay relevant and compete in a challenging marketplace. Our retail banking services and solutions address areas that comprehend automation from front-end channels and extending to back office core systems. We help in securing the digital bank’s environment by addressing the core methodologies and emerging technologies pertaining to open banking platforms, API driven frameworks and cognitive systems.  Our Capabilities in Retail Banking provided by our banking experts as a team in retail banking products spans multiple functional areas such as-</p>
              <ul>
                <li>Branch Banking Solutions</li>
                <li>Core Banking Transformation</li>
                <li>Customer analytics</li>
                <li>Online Banking Solutions</li>
                <li>Mobile and Digital Transformation</li>

              </ul>
              <p>To ensure our clients competitive positions in the world of information and mobility, we offer a broad range of modern delivery channel solutions that comprises of a suite of risk management tools, flexible configurable accounting and reporting inventory for unified customer information management. </p>
              <p>Clients can depend on our strong vendor relationships and our global experience across nations to simplify their corporate banking operations.</p>
            </div>
            <div className="col-md-4">
              <div className="right_content">
                <div className="border-tb mb-5">
                  <h2 className="heading2 mt-0">Wholesale Banking Services – Designed for the Unique Needs of Corporate Sector-</h2>
                  <p>Cylon Technologies Wholesale Banking Solutions transforms your businesses to align to the future of the trade finance industry by leveraging Blockchain, cloud, automation and analytics. Our goal of providing wholesale banking solutions is based on the premise of corporate banking principles of providing timely and secure financial services that are capable of supporting sophisticated strategies and corporate financial needs of the medium to large businesses, governments and other big institutions and corporate.</p>
                  <p>Our team of wholesale banking solution experts through their Enterprise IT Solutions will provide immense value for your organizations through innovative engagement models, transformative approaches and delivery excellence. Cylon Technologies wholesale banking solutions can be perfectly tailored to support the most exquisite corporate banking products and services in areas such as-</p>
                  <ul>
                  <li>Asset and Cash Flow  Management</li>
                  <li>Investments</li>
                  <li>Securities and Equities Management</li>
                  <li>FOREX</li>
                  <li>Loan Operations</li>
                  <li>Mutual Fund Management</li>
                  <li>Deposits and Liquidity Management</li>
                  <li>Credit Risk Management</li>
                  <li>Cash Management Services</li>
                  <li>Payments and Trade</li>
                  <li>Wholesale payments (EDI, Wire, ACH, SWIFT, Commercial cards)</li>
                  <li>Business Process Outsourcing Solutions</li>


                  </ul>
                </div>


              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default RetailWholesale;
